import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { Loading } from "../Loading";
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";
import { useEffect, useState } from "react";
import FormControlLabel from '@mui/material/FormControlLabel';
import './../../index.css';
import Paper from '@mui/material/Paper';
const columns = [
    { field: 'id', headerName: 'ID', width: 90   ,  editable: false,},
 // { field: 'Reserv_Id', headerName: 'Id', width: 20 },
  
 
  {
    field: 'Repairs_Date',
    headerName: 'date',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 100,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
  {
    field: 'Repairs_Desc',
    headerName: 'Description',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 100,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
  {
    field: 'Repairs_Refre_Date',
    headerName: 'Refrence Date',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 100,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
  {
    field: 'Repairs_Desc2',
    headerName: 'Refrence Description',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 100,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
  {
    field: 'Repairs_Result',
    headerName: 'Result',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 100,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
  {
    field: 'U_Name',
    headerName: 'Result',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 100,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
  {
    field: 'U_Refer_Id',
    headerName: 'Result',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 0,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
];

const paginationModel = { page: 0, pageSize: 5 };
export default function Repair_Data(props) {
console.log(props.data)
    const [checkboxSelection, setCheckboxSelection] = React.useState(true);
  const [disableMultipleRowSelection, setDisableMultipleRowSelection] =    React.useState(false);
    const [loading, setLoading] = useState(false);
  // setData(newData)

const   handleRowClick = (params) => {

   props.allupdate(
   params.row.id,
   params.row.Repairs_Date,
    params.row.Repairs_Desc, 
   params.row.Repairs_Desc2,
   params.row.Repairs_Refre_Date,
    params.row.Repairs_Result,
    params.row.U_Refer_Id,


  )
    };
   if(loading) {
    return "loading ...."
  } 

  return (
    <Paper sx={{ height: 250, width: '100%' }}>
    <DataGrid onRowClick={handleRowClick} 
      rows={props.data}
      columns={columns}
      getRowId={() => crypto.randomUUID()}
      initialState={{ pagination: { paginationModel } }}
      pageSizeOptions={[5, 10]}
    //  checkboxSelection
      sx={{ border: 0 ,fontFamily:'Roboto' , fontWeight:'normal' , fontSize: '14px',backgroundColor:'#F2F2F2'}}
     // onSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
    
    />
  </Paper>
  );
}